module.exports = __webpack_public_path__ + "static/media/kerrisdale-lumber.fdfe0725.jpg";